// import { useContext } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
// import { callApi } from "../utils/ApiCallV2";
import { callApi } from "../utils/ApiCallPostOnly";
// import { StaffFilterContext } from "../contexts/StaffFilterContext";
// import { useUserBranches } from "../state/userBranchListState";

export const useStaffList = (staffFilter) => {
  // const { staffFilter } = useContext(StaffFilterContext);
  const filter = {
    filter: { branchId: null, searchTerm: null },
    paging: { pageIndex: 1 },
  };
  filter.filter.searchTerm = staffFilter.search;
  filter.paging.pageIndex = staffFilter.page;
  // const { data } = useUserBranches();
  // const userBranches = data?.data.data.data.list.branch;
  const command = staffFilter.status;

  if (staffFilter.branchFilter === "All") {
    filter.filter.branchId = null;
  } else if (
    staffFilter.branchFilter === "Mine" &&
    staffFilter.myBranchesFilter === "All"
  ) {
    // Filter value equal to all the users branches
    // let userBranchFilter = "";
    // userBranches?.map((branch, index) => {
    //   const last = index === userBranches.length - 1;

    //   return last
    //     ? (userBranchFilter += branch.no)
    //     : (userBranchFilter += `${branch.no}|`);
    // });
    // filter.filter.branchId = userBranchFilter;
    filter.filter.branchId = "Mine";
  } else {
    // filter is equal to staffFilter.myBranchesFilter
    filter.filter.branchId = staffFilter.myBranchesFilter;
  }

  // const bodyData = {
  //   path: "staffList",
  //   command: command,
  //   data: JSON.stringify({ list: filter }),
  // };

  // return useQuery({
  //   queryKey: ["staffListState", bodyData],
  //   queryFn: async () => {
  //     const res = await callApi(bodyData);
  //     const data = await res.json();
  //     return data;
  //   },
  //   placeholderData: keepPreviousData,
  //   staleTime: 5000,
  // });
  return useQuery({
    queryKey: ["staffListState", command, filter],
    queryFn: async () =>
      callApi({
        path: "staffList",
        command: command,
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
